<template>
  <Landing>
    <FindPwd :type="'phone'" @next="next" @ready-to-get-code="getAuthCode"></FindPwd><!-- type: phone|email|all -->
  </Landing>
</template>
<script>
import Landing from '@/page/byl/landing.vue'
import FindPwd from '@/components/common/find-pwd/index.vue'
import { mapActions } from 'vuex'
export default {
  components: { Landing, FindPwd },
  mounted () {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('pwdreset', {
      validatePhone: 'validatePhone',
      getCode: 'getCode'
    }),
    getAuthCode (phone) {
      if (phone && phone !== (null || undefined || '')) {
        this.getCode(phone)
      }
    },
    next (f) {
      this.validatePhone(f)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/byl/auth/find-pwd-page.vue